import cn from "classnames"
import React, { useEffect, useState } from "react"
import { defaultPatternByHoleCount } from "../app/fixmethods/custom_holes"
import type Sign from "../app/sign"
import ControlPatternsIcons from "@/images/signomatic/custom_holes_patterns/index"

export const PATTERNS: Record<number, string[]> = {
  1: [
    "top_left",
    "top_center",
    "top_right",
    "middle_right",
    "bottom_right",
    "bottom_center",
    "bottom_left",
    "middle_left",
  ],
  2: ["top", "center_x", "bottom", "left", "center_y", "right"],
  4: ["rect", "rotated_rect"],
}

interface ControlPatternsProps {
  customHoleCount: number
  sign: Sign
  validity: Record<string, boolean>
}

const ControlPatterns: React.FC<ControlPatternsProps> = ({ customHoleCount, sign, validity }) => {
  const patterns = PATTERNS[customHoleCount]
  const defaultPattern = defaultPatternByHoleCount[customHoleCount]
  const [activePattern, setActivePattern] = useState<string>(defaultPattern)

  useEffect(() => {
    if (sign.state.customHoleControlPattern) {
      setActivePattern(sign.state.customHoleControlPattern)
    }
  }, [sign.state.customHoleControlPattern])

  return (
    <div className="flex gap-1 xl:gap-2">
      {patterns.map(pattern => {
        const Icon = ControlPatternsIcons[pattern]
        const isActive = activePattern === pattern

        return (
          <button
            key={pattern}
            type="button"
            disabled={!validity[pattern]}
            onClick={() => sign.updateState({ customHoleControlPattern: pattern })}
            className={cn(`rounded border hover:border-blue-500`, {
              "border-blue-500": isActive,
              "border-transparent": !isActive,
              "pointer-events-none opacity-30": !validity[pattern],
            })}
          >
            <Icon />
          </button>
        )
      })}
    </div>
  )
}

export default ControlPatterns
